import { render } from "./WaveCard.vue?vue&type=template&id=55e3c5aa&scoped=true"
import script from "./WaveCard.vue?vue&type=script&lang=js"
export * from "./WaveCard.vue?vue&type=script&lang=js"

import "./WaveCard.vue?vue&type=style&index=0&id=55e3c5aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e3c5aa"]])

export default __exports__